import { Table } from '@shinetools/lumen-react'
import type { ReactElement } from 'react'

import type { ExpertBalanceSheetColumnDef } from '../../../../hooks/useExpertBalanceSheetColumns'
import type { ExpertBalanceSheetTableRow } from '../../../../types/expertBalanceSheetView'

interface ExpertBalanceSheetTableHeaderProps<Row extends ExpertBalanceSheetTableRow> {
  columns: ExpertBalanceSheetColumnDef<Row>[]
}

export const ExpertBalanceSheetTableHeader = <Row extends ExpertBalanceSheetTableRow>({
  columns,
}: ExpertBalanceSheetTableHeaderProps<Row>): ReactElement => (
  <Table.Header>
    <Table.Row>
      {columns.map((column) => (
        <Table.HeaderCell
          align={typeof column.align === 'function' ? undefined : column.align}
          key={column.id}
          width={column.width}
        >
          {column.header}
        </Table.HeaderCell>
      ))}
    </Table.Row>
  </Table.Header>
)
